(function () {
  var drawerBound = false;

  function bindActivate(el, fn) {
    el.addEventListener('click', fn);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fn();
      }
    });
  }

  function initGsqSizeChartInDrawer() {
    var drawer = document.getElementById('gsq-size-chart-drawer');
    if (!drawer) return;

    var root =
      drawer.querySelector('.app-size-chart.schart') ||
      drawer.querySelector('.app-size-chart-country-root');
    if (!root) return;

    var countries = (root.getAttribute('data-countries') || '').split('|').filter(Boolean);
    var hasCountryToggle =
      countries.length > 0 && root.querySelector('.schart_country_switcher__option[data-country]');

    function setCountry(c) {
      if (!c || countries.indexOf(c) === -1) return;
      root.setAttribute('data-country', c);
      try {
        localStorage.setItem('schart_country', c);
      } catch (e) {}
      root.querySelectorAll('.schart_country_switcher__option').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-country') === c ? 'true' : 'false');
      });
    }

    if (hasCountryToggle && root.dataset.gsqCountryBound !== '1') {
      root.dataset.gsqCountryBound = '1';
      root.querySelectorAll('.schart_country_switcher__option').forEach(function (btn) {
        btn.style.cursor = 'pointer';
        btn.addEventListener('click', function () {
          setCountry(btn.getAttribute('data-country'));
        });
      });
    }

    if (hasCountryToggle) {
      var savedCountry = null;
      try {
        savedCountry = localStorage.getItem('schart_country');
      } catch (e) {}
      setCountry(savedCountry || root.getAttribute('data-country') || 'EU');
    }

    if (!root.querySelector('[data-app-measure-raw]')) return;

    var base = (root.getAttribute('data-app-base-unit') || 'cm').toLowerCase();
    var baseIsInch = base === 'inch';
    var IN_TO_CM = 2.54;
    var CM_TO_IN = 1 / 2.54;

    function fmt(n) {
      var v = Math.round(n * 10) / 10;
      return v % 1 === 0 ? String(v) : v.toFixed(1);
    }

    function parseRaw(raw) {
      if (raw == null) return { kind: 'text', s: '' };
      var s = String(raw).trim();
      if (baseIsInch) {
        s = s.replace(/\s*(?:inches|inch|in)\s*$/i, '');
      } else {
        s = s.replace(/\s*cm\s*$/i, '');
      }
      if (!s) return { kind: 'text', s: String(raw).trim() };
      var range = s.match(/^(\d+(?:[.,]\d+)?)\s*[-\u2013\u2014]\s*(\d+(?:[.,]\d+)?)$/);
      if (range) {
        var a = parseFloat(range[1].replace(',', '.'));
        var b = parseFloat(range[2].replace(',', '.'));
        if (isFinite(a) && isFinite(b) && a > 0 && b > 0) return { kind: 'range', a: a, b: b };
      }
      var n = parseFloat(s.replace(',', '.'));
      if (isFinite(n) && n > 0) return { kind: 'num', n: n };
      return { kind: 'text', s: s };
    }

    function render(raw) {
      var p = parseRaw(raw);
      if (p.kind === 'range') {
        if (baseIsInch) {
          return { cm: fmt(p.a * IN_TO_CM) + '–' + fmt(p.b * IN_TO_CM), inch: fmt(p.a) + '–' + fmt(p.b) };
        }
        return { cm: fmt(p.a) + '–' + fmt(p.b), inch: fmt(p.a * CM_TO_IN) + '–' + fmt(p.b * CM_TO_IN) };
      }
      if (p.kind === 'num') {
        if (baseIsInch) return { cm: fmt(p.n * IN_TO_CM), inch: fmt(p.n) };
        return { cm: fmt(p.n), inch: fmt(p.n * CM_TO_IN) };
      }
      return { cm: p.s, inch: p.s };
    }

    function fill() {
      root.querySelectorAll('[data-app-measure-raw]').forEach(function (el) {
        var raw = el.getAttribute('data-app-measure-raw');
        var out = render(raw);
        var sCm = el.querySelector('span[data-unit="cm"]');
        var sIn = el.querySelector('span[data-unit="inch"]');
        if (sCm) sCm.textContent = out.cm;
        if (sIn) sIn.textContent = out.inch;
      });
    }

    function setUnit(unit) {
      if (unit !== 'inch' && unit !== 'cm') return;
      root.setAttribute('data-unit', unit);
      try {
        localStorage.setItem('schart_unit', unit);
      } catch (e) {}
      root.querySelectorAll('.schart_unit_switcher__option[data-unit]').forEach(function (el) {
        el.setAttribute('aria-pressed', el.getAttribute('data-unit') === unit ? 'true' : 'false');
      });
    }

    fill();

    var def = (
      root.getAttribute('data-app-base-unit') ||
      root.getAttribute('data-default-unit') ||
      'cm'
    ).toLowerCase();
    if (def !== 'inch' && def !== 'cm') def = 'cm';
    var savedUnit = null;
    try {
      savedUnit = localStorage.getItem('schart_unit');
    } catch (e) {}
    setUnit(savedUnit === 'inch' || savedUnit === 'cm' ? savedUnit : def);

    var switcher = root.querySelector('.schart_unit_switcher');
    if (switcher && switcher.dataset.gsqUnitBound !== '1') {
      switcher.dataset.gsqUnitBound = '1';
      switcher.querySelectorAll('.schart_unit_switcher__option[data-unit]').forEach(function (el) {
        el.style.cursor = 'pointer';
        var unit = el.getAttribute('data-unit');
        bindActivate(el, function () {
          setUnit(unit);
        });
      });
      var slider = switcher.querySelector('.schart_unit_switcher__slider');
      if (slider) {
        slider.style.cursor = 'pointer';
        bindActivate(slider, function () {
          var u = (root.getAttribute('data-unit') || 'cm').toLowerCase();
          setUnit(u === 'cm' ? 'inch' : 'cm');
        });
      }
    }
  }

  function bindDrawer() {
    var drawerEl = document.getElementById('gsq-size-chart-drawer');
    if (!drawerEl || drawerBound) return;
    drawerBound = true;
    drawerEl.addEventListener('dialog:open', initGsqSizeChartInDrawer);
  }

  function remountSizeChartDrawer() {
    drawerBound = false;
    bindDrawer();
    initGsqSizeChartInDrawer();
  }

  bindDrawer();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindDrawer();
      initGsqSizeChartInDrawer();
    });
  } else {
    initGsqSizeChartInDrawer();
  }

  document.addEventListener('shopify:section:load', remountSizeChartDrawer);
  document.addEventListener('gsq:size-chart-drawer:mount', remountSizeChartDrawer);
})();
